import { Component } from '@angular/core';
import {IonicPage, ModalController, NavController, NavParams, ViewController} from 'ionic-angular';
import {Customer} from "../../app/classes/customer";

/**
 * Generated class for the OderSummaryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

import {Order} from "../../app/classes/order";
import {Cart} from "../../app/classes/cart";
import {CartService} from "../../app/services/cart.service";
import {UserService} from "../../app/services/user.service";
import {AnalyticsService} from "../../app/services/analytics.service";
import {StorageService} from "../../app/services/storage.service";
import {StaticPage} from "../static/static";
import { Http } from '@angular/http';


@IonicPage()
@Component({
  selector: 'page-order-summary',
  templateUrl: 'order-summary.html',
  providers: [
    CartService, UserService]
})
export class OrderSummaryPage {
  public cart? : Cart;
  public order? : Order;
  public customer? : Customer;
  public address;


  public delivery;


  constructor(public storage: StorageService,public http: Http, public navCtrl: NavController, private analytics: AnalyticsService, public cartService: CartService,public userService: UserService,public viewCtrl: ViewController, public navParams: NavParams,public modalCtrl: ModalController) {
    this.cart = cartService.getCart();
    this.order = new Order(navParams.get("order"));
    this.address = navParams.get('address');
    this.delivery = navParams.get('delivery');
    this.customer = Customer.cachedOrCreate(this.http) as Customer;


    this.init();
  }

  async init() {
    console.log(this.navParams)
  }

  ionViewDidLoad() {
    console.log("THIS:::::");

    console.log(this.delivery);

    console.log('ionViewDidLoad OderSummaryPage');
  }

  showPage(page) {
    this.analytics.trackView(page);
    console.log(this.customer.pages)
    this.navCtrl.push(StaticPage, {"page": page})
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-summary/order-summary.ts